export default class GroupUsers {
  currentUsers: Array<string> = [];
  usersRequesting: Array<string> = [];  

  constructor({currentUsers, usersRequesting}: any) {
    this.currentUsers = currentUsers ? currentUsers : [];
    this.usersRequesting = usersRequesting ? usersRequesting : [];
  }
}
